/* this file is in use (although not mentioned in the code base it's defined in database)
Expense claim authorisation pop
perhaps it could be refactored to the default modal controller (xmsModal) and removed ?
*/
(function() {
    'use strict';

    var ExpenseClaimCtrl = function ($http, $scope, $uibModalInstance, $window) {

    	 console.log("Inside ExpenseClaimCtrl");

          $scope.pageModel = {};


          $scope.cancelPop = function($event) {
            $event.preventDefault();
            $uibModalInstance.dismiss('cancel');
        }
    }

    ExpenseClaimCtrl.$inject = ['$http','$scope','$uibModalInstance','$window'];
    angular.module('app').controller('ExpenseClaimCtrl',ExpenseClaimCtrl);
}());
